export const PRIORITY_LABELS = {
  price: 'Lower rent',
  commute: 'Shorter commute',
  anchor: 'Close to chosen location',
  area: 'More living space',
  daily_convenience: 'Daily convenience',
  recreation: 'Recreation',
} as const;

export type PriorityDimension = keyof typeof PRIORITY_LABELS;

/** Preserve the server's priority order; legacy scalar styles are read-only compatibility. */
export const normalizePriorityStack = (value: unknown): PriorityDimension[] => {
  if (!Array.isArray(value)) {
    if (value === 'value' || value === 'value_focused') return ['price'];
    if (value === 'commute' || value === 'commute_focused') return ['commute'];
    return [];
  }
  return Array.from(new Set(value.filter((item): item is PriorityDimension => (
    typeof item === 'string' && Object.prototype.hasOwnProperty.call(PRIORITY_LABELS, item)
  )))).slice(0, 3);
};
